@if (embeddedTabs.length) {
  <cotecna-tabs
    #dynamicTabs
    [tabs]="embeddedTabs"
    (tabChanged)="onTabChanged($event)"
    >
  </cotecna-tabs>
}

@if (this.embedConfig.accessToken) {
  <div>
    <powerbi-report [embedConfig]="embedConfig" [cssClassName]="reportClass">
    </powerbi-report>
  </div>
}
